import React from 'react';
import ReactDOM from 'react-dom';

import { Home } from './Home';

import './index.css';

ReactDOM.render(
    <Home />,
    document.getElementById('root')
);